import { OcpsPolicy, isOcpsPolicyEnabled } from "owa-ocps-policy-store";
import { isOcpsPolicyEnabled as isOwsPrimeOcpsPolicyEnabled, PrivacyPolicySettingId, } from "owa-owsprime-policies-store";
import { isPrivacyRoamingEnabled } from "../utils/isPrivacyRoamingEnabled";
import { getGlobalSettingsAccountMailboxInfo } from "owa-account-source-list-store";

export const isAnalyzeContentAllowedByPolicy = (): boolean => {
    if (!isPrivacyRoamingEnabled()) {
        return true;
    }
    
    const mailboxInfo = getGlobalSettingsAccountMailboxInfo();
    return isOwsPrimeOcpsPolicyEnabled(PrivacyPolicySettingId.OfficeExperiencesAnalyzingContent, mailboxInfo, () => isOcpsPolicyEnabled(OcpsPolicy.ExperiencesAnalyzingContent, true /* enabledIfUndefined */, mailboxInfo));
};
